// extracted by mini-css-extract-plugin
module.exports = {"root":"RetailerBlok_root__H57dC","link":"RetailerBlok_link__GVc6g","openingHours":"RetailerBlok_openingHours___hmCF"};